import HTTP from "../../http";

const ORDERS_ENDPOINT = "/orders";
const CONFIRM_ORDER_ENDPOINT = "/confirm/";

export async function confirmOrder(order) {
  return await HTTP.put(
    ORDERS_ENDPOINT + CONFIRM_ORDER_ENDPOINT,
    {
      order
    },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
